export default __webpack_public_path__ + "static/iphoneXr-562b9cf51caac6cf75c9972ee9673763.jpg";